/* eslint-disable import/prefer-default-export */
import {Types} from '../../request';
import ApiTag from '../apiTags';

// API docs ref - #177
// Input
// {
//     }

export const getLoginTickerText = data => {
  return {
    url: '/commons/TICKERUSLOGIN',
    payload: data,
    type: Types.POST,
    tag: ApiTag.LOGIN_TICKER_TEXT,
    headers: {}
  };
};
